import { useSelector } from 'react-redux';

/**
 * Hook for accessing translations from Redux
 * Replaces react-intl's useIntl hook
 */
export const useTranslations = () => {
  const translations = useSelector(state => state.intl.messages);
  const locale = useSelector(state => state.intl.locale);

  const formatTranslation = (key, variables = {}) => {
    const template = translations[key] || key.replace(/_/g, ' ');
    return template.replace(/{(\w+)}/g, (_, k) => variables[k] || `{${k}}`);
  };

  return { translations, locale, formatTranslation };
};